import React from "react";
import { techStack } from "../../data/companyData";
import "./SaasSections.css";

export default function TechStackSection() {
  return (
    <section className="saas-section tech-stack-section" id="tech-stack-section">
      <h2 className="saas-section__title">TECHNOLOGY STACK</h2>
      <div className="saas-section__header">
        <p className="saas-section__intro">{techStack.intro}</p>
      </div>
      <div className="saas-section__body">
        <div className="tech-stack-categories">
          {techStack.categories.map((category) => (
            <div key={category.title} className="tech-stack-category">
              <h3 className="tech-stack-category__title">{category.title}</h3>
              <div className="tech-stack-category__items">
                {category.items.map((item) => (
                  <span key={item} className="tech-stack-category__item">
                    {item}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="infra-diagram" aria-hidden="true">
          <div className="infra-diagram__flow">
            <span className="infra-diagram__node">Client Apps</span>
            <span className="infra-diagram__arrow">→</span>
            <span className="infra-diagram__node">API Gateway</span>
            <span className="infra-diagram__arrow">→</span>
            <span className="infra-diagram__node">Microservices</span>
            <span className="infra-diagram__arrow">→</span>
            <span className="infra-diagram__node">AI / RAG Layer</span>
            <span className="infra-diagram__arrow">→</span>
            <span className="infra-diagram__node">AWS Cloud</span>
          </div>
        </div>
      </div>
    </section>
  );
}
